import React from 'react';
import { Check, X, Clock, Users } from '@phosphor-icons/react';
import { fmtDate } from './utils';

export const PendingTab = ({ pending, onApprove, onReject }) => {
  if (pending.length === 0) {
    return (
      <div className="card" style={{ padding: '32px', textAlign: 'center', color: '#5E5F66' }}>
        <Users size={40} style={{ opacity: 0.4, marginBottom: '10px' }} />
        <p style={{ margin: 0 }}>Aucune inscription en attente</p>
      </div>
    );
  }
  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      {pending.map(user => (
        <div key={user.id} className="card" data-testid={`pending-user-${user.id}`}>
          <div style={{ padding: '18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
              <div style={{ width: '42px', height: '42px', borderRadius: '50%', backgroundColor: '#FFF3E0', color: '#EF6C00', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700' }}>{(user.name || '?').charAt(0).toUpperCase()}</div>
              <div>
                <div style={{ fontWeight: '700' }}>{user.name}</div>
                <div style={{ color: '#5E5F66', fontSize: '0.85rem' }}>{user.email}</div>
                <div style={{ color: '#9E9EA7', fontSize: '0.8rem', display: 'flex', gap: '4px', alignItems: 'center', marginTop: '2px' }}><Clock size={12} /> {fmtDate(user.created_at)}</div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button className="btn btn-primary" onClick={() => onApprove(user.id, user.name)} data-testid={`approve-btn-${user.id}`} style={{ backgroundColor: '#2E7D32' }}><Check size={14} /> Approuver</button>
              <button className="btn btn-secondary" onClick={() => onReject(user.id, user.name)} data-testid={`reject-btn-${user.id}`} style={{ color: '#C62828', borderColor: '#C62828' }}><X size={14} /> Refuser</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
